module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAG1BMVEUAAABmZmZmZmZlZWVmZmZmZmZmZmZlZWVmZmY/PKwaAAAACHRSTlMAgNbAmYdwEAQ5ZQMAAACQSURBVDjLY6A+COqAAhVUcY4OOGhAkfBASLSiSGg0wlgSTSgSHQ0IQymQEASCjkZBKJDoAJEgcaYOLMAAnwSDIBZAfhAKAHFhAQMDezuQwYgQZ2oGhYoByCEQBoqnOhrgjFGJwSyRkcDAwNaGIQED9Jdg6hBAiDN2KMDZLKhJPQBJNzJANpdVAyHc5MBAZQAAe/iLcXwYWKsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/resource/delete.png
// module id = 3Nt4
// module chunks = 1